import footer from './footer';
import headerWithoutLogin from './headerWithoutLogin';

export default {
  'component.tagSelect.expand': '展開',
  'component.tagSelect.collapse': '折りたたむ',
  'component.tagSelect.all': 'すべて',

  ...footer,
  ...headerWithoutLogin,
};
